/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */

import Api from '../../../services/api';
import { cancel, take, takeLatest, takeEvery } from "redux-saga/effects";
import { types } from "./W06F0009_actions";
import { delay } from "redux-saga";

export default function W06F0009Sagas() {
    return [
        watchGetCbEmployees(),
        watchGetCbCustomer(),
        watchGetCboDeliveryMethod(),
        watchGetCboPorts(),
        watchGetCboPaymentMenthod(),
        watchGetCboBanks(),
        watchGetMasterSupplement(),
        watchGetDetailSupplement(),
        watchGetCboUnit(),
        watchGetCboMarking(),
        watchGetCboPackingMethod(),
        watchGetCboPackingType(),
        watchGetCboPaymentTerm(),
        watchGetDecimalQuantity(),
        watchloadFormAddNew(),
        watchloadFormEdit(),
        watchGetCboTypeAppendix(),
        watchSubContractNo(),
        watchCheckSubContractNo(),
        watchOnSave(),
        watchOnEdit(),
        watchgetDataDisplay(),
        watchGetCbSubContractType(),
    ];
}
export function* getCbEmployees(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-employee', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getCbEmployees error')
    }
}
export function* watchGetCbEmployees() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_EMPLOYEE, getCbEmployees);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getCbCustomer(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w91f0001/load-objects', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get grid object customer error');
    }
}
export function* watchGetCbCustomer() {
    while (true) {
        const watcher = yield takeEvery(types.W06F0009_GET_CBO_CUSTOMER, getCbCustomer);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo delivery method
export function* getCboDeliveryMethod(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-delivery-method');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo delivery method error');
    }

}
export function* watchGetCboDeliveryMethod() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_DELIVERY_METHOD, getCboDeliveryMethod);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo ports
export function* getCboPorts(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-port');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo ports error');
    }

}
export function* watchGetCboPorts() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_PORTS, getCboPorts);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo payment menthod
export function* getCboPaymentMenthod(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-payment-method');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo payment method error');
    }

}
export function* watchGetCboPaymentMenthod() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_PAYMENT_METHOD, getCboPaymentMenthod);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo banks
export function* getCboBanks(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-bank');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo banks error');
    }

}
export function* watchGetCboBanks() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_BANKS, getCboBanks);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get master supplement
export function* getMasterSupplement(data) {
    try {
        const response = yield Api.put('/w05f0000/get-master-supplement', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get master supplement error');
    }
}
export function* watchGetMasterSupplement() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_MASTER_SUPPLEMENT, getMasterSupplement);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get detail supplement
export function* getDetailSupplement(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w06f0000/get-detail-supplement', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get detail supplement error');
    }
}
export function* watchGetDetailSupplement() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_DETAIL_SUPPLEMENT, getDetailSupplement);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo marking
export function* getCboUnit(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-unit', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo marking error');
    }
}
export function* watchGetCboUnit() {
    while (true) {
        const watcher = yield takeEvery(types.W06F0009_GET_CBO_UNIT, getCboUnit);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo marking
export function* getCboMarking(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-marking', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo marking error');
    }
}
export function* watchGetCboMarking() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_MARKING, getCboMarking);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo packing method
export function* getCboPackingMethod(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-packing-method');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo packing method error');
    }
}
export function* watchGetCboPackingMethod() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_PACKING_METHOD, getCboPackingMethod);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo packing type
export function* getCboPackingType(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-packing-type', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo packing type error');
    }
}
export function* watchGetCboPackingType() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_PACKING_TYPE, getCboPackingType);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo payment term
export function* getCboPaymentTerm(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-payment-term');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo payment term error');
    }
}
export function* watchGetCboPaymentTerm() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_PAYMENT_TERM, getCboPaymentTerm);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get decimal quantity
export function* getDecimalQuantity(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-decimal-quantity', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get decimal quantity error');
    }
}
export function* watchGetDecimalQuantity() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_DECIMAL_QUANTITY, getDecimalQuantity);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//load form add new
export function* loadFormAddNew(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w06f0009/load-form-add-new', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('load form add new error');
    }
}
export function* watchloadFormAddNew() {
    while (true) {
        const watcher = yield takeEvery(types.W06F0009_LOAD_FORM_ADD_NEW, loadFormAddNew);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//load form edit
export function* loadFormEdit(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w06f0009/load-form-edit', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('load form add new error');
    }
}
export function* watchloadFormEdit() {
    while (true) {
        const watcher = yield takeEvery(types.W06F0009_LOAD_FORM_EDIT, loadFormEdit);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

//get cbo type appendix
export function* getCboTypeAppendix(data) {
    try {
        const response = yield Api.get('/w05f0009/combo-type-of-appendix', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo type appendix error');
    }
}
export function* watchGetCboTypeAppendix() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_CBO_TYPE_APPENDIX, getCboTypeAppendix);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* subContractNo(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0009/last-key', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('subContractNo error');
    }
}
export function* watchSubContractNo() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_SUBCONTRACTNO, subContractNo);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* checkSubContractNo(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0009/check', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('checkSubContractNo error');
    }
}
export function* watchCheckSubContractNo() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_CHECK_SUBCONTRACTNO, checkSubContractNo);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* onSave(data) {
    try {
        yield delay(300);
        const response = yield Api.post('/w06f0009/add', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('onSave error');
    }
}
export function* watchOnSave() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_SAVE, onSave);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* onEdit(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w06f0009/edit', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('onEdit error');
    }
}
export function* watchOnEdit() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_EDIT, onEdit);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getDataDisplay(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w06f0000/get-combo-transType', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('getDataDisplay error');
    }
}
export function* watchgetDataDisplay() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_DATA_DISPLAY, getDataDisplay);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCbSubContractType(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w06f0009/load-sub-contract-type', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('getCbSubContractType error');
    }
}
export function* watchGetCbSubContractType() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0009_GET_SUB_CONTRACT_TYPE, getCbSubContractType);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}